export class Location {
  public name: string;
  public address: string;
  public lat: number;
  public long: number;
  coords: {
    longitude: number;
    latitude: number;
  };
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/model/location.ts